import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { HomeComponent } from './client/pages/home/home.component';
import { SelectPlanComponent } from './client/pages/select-plan/select-plan.component';
import { SignInComponent } from './client/pages/sign-in/sign-in.component';
import { AccountViewComponent } from './client/pages/account-view/account-view.component';
import { ManagePlanComponent } from './client/pages/manage-plan/manage-plan.component';
import { MdnComponent } from './client/pages/mdn/mdn.component';
import { HealthCheckComponent } from './client/pages/health-check/health-check.component';
import { MatRadioModule } from '@angular/material/radio';
import { MdnChangeInformationComponent } from './client/pages/select-plan/mdn-change-information/mdn-change-information.component';
import { ReviewPlanComponent } from './client/pages/review-plan/review-plan.component';
import { OrderConfirmationComponent } from './client/pages/select-plan/order-confirmation/order-confirmation.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { TncComponent } from './client/pages/select-plan/tnc/tnc.component';
import { UniversalErrorComponent } from './client/pages/universal-error/universal-error.component';
import { MultipleVehicleInfoComponent } from './client/pages/select-plan/multiple-vehicle-info/multiple-vehicle-info.component';

@NgModule({
  declarations: [
    MdnComponent,
    HealthCheckComponent,
    HomeComponent,
    SelectPlanComponent,
    SignInComponent,
    AccountViewComponent,
    ManagePlanComponent,
    TncComponent,
    MdnChangeInformationComponent,
    ReviewPlanComponent,
    OrderConfirmationComponent,
    UniversalErrorComponent,
    MultipleVehicleInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    MatRadioModule,
    NgxMaskModule.forRoot()
  ]
})
export class CoreModule { }
